import { _t } from '@/i18n/t';

export const buildGreeting = (firstName?: string | null) => {
  const name = firstName?.trim();
  return name
    ? _t('assistant.greeting.named', { name })
    : _t('assistant.greeting.anonymous');
};
